<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MPxQXy/tc-custom/9781608462285.jpg?1705404080918" alt="This image is the cover for the book Howard Zinn Speaks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Howard Zinn Speaks
      </h1>
      <p class="bookDescription body article font2">
        <b>A wide-ranging collection of speeches—many published here for the first time—by the historian and author of <i>A People’s History of the United States</i>.</b><br/>  <br/> Howard Zinn has illuminated our history like no other US historian. This collection of his speeches on protest movements, racism, war, and American history covers more than four decades of his active engagement with the audiences he inspired with his humor, insight, and clarity.<br/>  <br/> This volume features Zinn’s impassioned and erudite statements on the war in Vietnam, abolishing the death penalty, the legacy of Emma Goldman, the myth of American exceptionalism, the Obama Administration, and much more.<br/>  <br/> “Reading Howard’s spoken words, I feel that I am almost hearing his voice again—his stunning pitch-perfect ability to capture the moment and the concerns and needs of the audience, whoever they may be, always enlightening, often stirring, an amalgam of insight, critical history, wit, blended with charm and appeal.” —Noam Chomsky, leading public intellectual and author of <i>Hopes and Prospects</i><br/>  <br/> “With ferocious moral clarity and mischievous humor, Howard turned routine antiwar rallies into profound explorations of state violence and staid academic conferences into revival meetings for social change.” —Naomi Klein, author of <i>No Is Not Enough</i> and <i>The Battle For Paradise</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Howard Zinn, Anthony Arnove
      </h2>
      
      <p class="authorDescription body article">HOWARD ZINN (August 24, 1922 — January 27, 2010) was a historian, playwright, and activist. He wrote the classic A People’s History of the United States, The book, which has sold more than two million copies, has been featured on The Sopranos and Simpsons, and in the film Good Will Hunting. The book has appeared multiple times on the New York Times best-seller list.Zinn was the author of many books, including an autobiography, You Can’t Be Neutral on a Moving Train, and the plays Marx in Soho, Emma, and Daughter of Venus. He received the Lannan Foundation Literary Award for Nonfiction and the Eugene V. Debs award for his writing and political activism.*ANTHONY ARNOVE wrote, directed, and produced The People Speak with Howard Zinn, Chris Moore, Josh Brolin, and Matt Damon. This critically acclaimed documentary is the film companion to Howard Zinn’s best selling book A People’s History of the United States and its primary source companion, Voices of a People’s History, which Arnove co-edited with Zinn.Arnove’s writing has appeared in O Magazine, The Financial Times, The Nation, Monthly Review, In These Times, L’Humanite, Le Nouvel Observateur, Mother Jones, and other publications. He has appeared on BBC, Democracy Now!, Sky News, ABC Radio in Australia, Alternative Radio, CounterSpin, Air America, and public radio programs across the country.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Haymarket Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?415dc77c